import { createAsyncThunk } from '@reduxjs/toolkit';
import type { IState } from '../store';
import { persistUserPreferences } from './persistUserPreferences';

export const clearBudgetFilters = createAsyncThunk<void, void, { state: IState }>(
  'uiView/clearBudgetFilters',
  (_, { dispatch }) => {
    dispatch(persistUserPreferences());
  }
);
